// this is an autogenerated file from DesignSystem/AutomationTask/Tags/Content/mutation-create-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_AutomationTask_Tags_Content($name: String!) {
  insert_tasks_tags_one(object: { type: TASK, name: $name }) {
    id
    name
  }
}

`